module.exports = __webpack_public_path__ + "1f2bf5563b9acf6b7993cd7e5aef77d2.png";